import {
  Toast
} from 'vant';

export default {
  data (){
    return {
      showBase: false,
      sku: {
        // 所有sku规格类目与其值的从属关系，比如商品有颜色和尺码两大类规格，颜色下面又有红色和蓝色两个规格值。
        // 可以理解为一个商品可以有多个规格类目，一个规格类目下可以有多个规格值。
        tree: [

        ],
        // 所有 sku 的组合列表，比如红色、M 码为一个 sku 组合，红色、S 码为另一个组合
        list: [
        ]
      },

    }
  },
  methods: {
    onBuyClicked () {
      Toast('点击购买');
    },
    onAddCartClicked (){
      this.$router.push('cart')
      Toast('点击加购物车');
    }
  }
}